/* RestoreSummaryComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./RestoreSummaryRenderer");

class RestoreSummaryComponent extends EventEmitter {
    constructor(restoreResults, logger) {
        super();
        this._logger = logger;
        this._restoreResults = restoreResults;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {
        // Register any listeners if needed in the future
    }

    _unregisterListeners() {
        // Unregister any listeners if needed in the future
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "restoreSummaryComponent.shutdown() error.");
            }
        );
    }

    sendOk() {
        this._context.resolve({});
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    getRestoreResults() {
        return this._restoreResults;
    }

    get restoreResults() {
        return this.getRestoreResults();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    // No handler methods at the moment
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    // No private methods at the moment
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    // No public API methods at the moment
    /*******************************************/
    /* END PUBLIC API METHODS */
}

module.exports = RestoreSummaryComponent;
